import { useRef, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { Grid, Switch } from '@mui/material';
import CustomField from 'ui-component/formik/CustomField';
import { useFormik, Form, FormikProvider, FieldArray } from 'formik';
import useBreadcrumbs from 'use-react-router-breadcrumbs';
import { Cancel } from '@mui/icons-material';
import { AddMasterEmailTemplate, FetchEmailTypes, FetchMasterEmailTemplateDetails, UpdateMasterEmailTemplateForm } from '../../api';
import { useParams, useNavigate } from 'react-router';
import { toast, ToastContainer } from 'react-toastify';
import Loading from 'views/Loading';
import BreadcrumbHeader from 'ui-component/BreadcrumbHeader';
import SelectField from 'ui-component/formik/SelectField';
import { Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import MenuIcon from '@mui/icons-material/Menu';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useState } from 'react';
import { Box, Stack } from '@mui/system';

const CreateEmailTemplate = () => {
    const { id: master_id } = useParams();
    const isEditMode = !!master_id;
    const docRef = useRef();
    const [search, setSearch] = useState('');
    const [sort, setSort] = useState(-1);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(20);
    const navigate = useNavigate();
    useEffect(() => {
        // Adding custom styles to ensure hover color is updated
        const styleElement = document.createElement('style');
        styleElement.innerHTML = `
          .ql-editor p {
            color: black !important;
          }
          .ql-container {
            background-color: #fafafa !important;
            border-radius: 0 0 4px 4px !important;
            overflow: hidden;
          } 
          .ql-toolbar {
            background-color: #fafafa !important;
            border-radius: 4px 4px 0 0 !important;
          } 
        `;
        document.head.appendChild(styleElement);
      
        // Cleanup on component unmount
        return () => {
          document.head.removeChild(styleElement);
        };
      }, []);
    const {
        isLoading: ismasterTemplateLoading,
        data: masterTemplateData,
        status: masterTemplateStatus
    } = FetchMasterEmailTemplateDetails(master_id, 'edit');
    const { mutateAsync: uploadMasterEmailTemplate, status: uploadMasterEmailTemplateStatus, error: uploadMasterEmailTemplateError } = AddMasterEmailTemplate();
    const {
        mutateAsync: UpdateMasterTemplate,
        isLoading: isLoadingUpdateUpdateMasterTemplate,
        status: UpdateMasterTemplateStatus,
        error: UpdateMasterTemplateError
    } = UpdateMasterEmailTemplateForm();
        const {
            isLoading: isCompletedDealsLoading,
            isRefetching: isCompletedDealsRefetching,
            data: completedDealsData,
            refetch: refetchListing,
            status: dealStatus
        } = FetchEmailTypes({ page, sort, search, limit });
        // console.log(completedDealsData?.data.map(iteam => iteam.value), "dededededededed")
        const eventTypeOptions =
        completedDealsData?.data?.map((item) => ({
    label: item.value,
    value: item.value,
  })) || [];
    const initialValues = {
        name:'',
        eventType:'',
        subject: '',
        content: '',
    };

    console.log(masterTemplateData,"masterTemplateDatamasterTemplateDatamasterTemplateDatamasterTemplateDatamasterTemplateDatamasterTemplateData")

    const formik = useFormik({
        initialValues: !ismasterTemplateLoading && isEditMode ? masterTemplateData : initialValues,
        validateOnChange: false,
        validateOnBlur: true,
        enableReinitialize: true,
        onSubmit: (values) => {
            const payload = {
                name: values.name,
                eventType: values.eventType,
                subject: values.subject,
                content: values.content
            };

            if (isEditMode) {
                UpdateMasterTemplate({ payload, id: master_id });
            } else {
                uploadMasterEmailTemplate({ payload });
            }
        }
    });
    const routes = [{ path: '/', breadcrumb: '' }];
    useEffect(() => {
        if (uploadMasterEmailTemplateStatus == 'success') {
            formik.resetForm();
            toast.success('Template Create!', {
                position: 'top-left',
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: 'colored',
                onClose: () => {
                    navigate('/emailTemplate');
                }
            });
        }
        if (uploadMasterEmailTemplateStatus == 'error') {
            toast.error(uploadMasterEmailTemplateError?.response?.data?.message, {
                position: 'top-left',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: 'colored'
            });
        }
    }, [uploadMasterEmailTemplateStatus]);

    useEffect(() => {
        if (UpdateMasterTemplateStatus == 'success') {
            toast.success('Template Update!', {
                position: 'top-left',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: 'colored',
                onClose: () => {
                    navigate('/emailTemplate');
                }
            });
        }
        if (UpdateMasterTemplateStatus == 'error') {
            toast.error(UpdateMasterTemplateError?.response?.data?.message, {
                position: 'top-left',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: 'colored'
            });
        }
    }, [UpdateMasterTemplateStatus]);

    if (isEditMode && ismasterTemplateLoading) {
        return (
            <div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Loading />
            </div>
        );
    }
    return (
        <>
                <div style={{ display: "flex", flexDirection: 'column', height: '100%' }}>
            <BreadcrumbHeader title={isEditMode ? 'Edit Email Template' : 'Create Email Template'} shouldGoBack />
            <ToastContainer />
             <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%',
                    backgroundColor:'#FFFAF5'
                }}
                >
            <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit} style={{
                    paddingBottom: '15px',
                            marginTop: 10,
                            marginBottom: 10,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'flex-start',
                            flex: 1,
                            width:'100%',
                            maxWidth:'900px',
                            border: '1px solid rgb(235, 232, 251)',
                            borderRadius:"10px",
                            backgroundColor:"#fff",
                }}>
                    <div className="custom-menu-block view-investor-block">
                    <div className="row mt-4">
                            <div className="col-6">
                                <CustomField name="name" label="Title"/>
                            </div>
                            <div className="col-6">
                                <SelectField name="eventType" label="Event Type" options={eventTypeOptions}/>
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-12">
                                <CustomField name="subject" label="Subject" />
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-12 mb-3">
                            <ReactQuill
                                style={{
                                height: '150px' }}
                                placeholder='Content'
                                // onChange={handelOverviewChange}
                                value={formik?.values?.content}
                                onChange={(value) => formik.setFieldValue('content', value)}
                            />
                            </div>
                        </div>
                       
                    </div>
                </Form>
            </FormikProvider>
            </div>
            <Box  sx={{
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        width: '100%',
                        backgroundColor: '#FFFAF5',
                        justifyContent:'center',
                        zIndex: 1000,
                    }}>
 <Grid item p={1} display="flex" justifyContent="center">
                <Stack direction="row" spacing={2}>
                                <button type="submit" className="button-799">
                                    Submit
                                </button>
                           </Stack>
                           </Grid>
                    </Box>
            </div>
        </>
    );
};

export default CreateEmailTemplate;
